'use client';

import { usePathname } from '@/i18n/routing';

// The consumer app is a phone-width column; the admin/客服 dashboard is a wide,
// responsive layout (they may manage on a desktop). One shell, two widths.
export default function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isAdmin = pathname.startsWith('/admin');
  return (
    <div
      className={
        isAdmin
          ? 'mx-auto min-h-dvh w-full max-w-6xl' // no header/nav padding — admin has its own chrome
          : 'mx-auto min-h-dvh w-full max-w-md pb-20 pt-14'
      }
    >
      {children}
    </div>
  );
}
